import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, MobileSidebar } from './Sidebar';
import { Header } from './Header';
import { CommandPalette } from '@/components/CommandPalette';
import { EmpresaCreateModal } from '@/components/EmpresaCreateModal';

export function AppShell() {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const isMac = navigator.platform.toLowerCase().includes('mac');
      const meta = isMac ? e.metaKey : e.ctrlKey;
      if (meta && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen((o) => !o);
      } else if (meta && e.key.toLowerCase() === 'n' && !e.shiftKey) {
        e.preventDefault();
        setCreateOpen(true);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="flex h-full flex-col">
      <Header
        onSearchClick={() => setPaletteOpen(true)}
        onNewClick={() => setCreateOpen(true)}
        onMenuClick={() => setNavOpen(true)}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <MobileSidebar open={navOpen} onClose={() => setNavOpen(false)} />
        <main className="flex-1 overflow-y-auto bg-background px-4 py-4 md:px-6 md:py-5">
          <Outlet />
        </main>
      </div>
      <CommandPalette
        open={paletteOpen}
        onOpenChange={setPaletteOpen}
        onOpenNewEmpresa={() => setCreateOpen(true)}
      />
      <EmpresaCreateModal open={createOpen} onOpenChange={setCreateOpen} />
    </div>
  );
}
